import FanLiveEventPublicPage from './FanLiveEventPublicPage';

export default FanLiveEventPublicPage;